<template>
  <div class="desktop-class-selector">
    <ClassSelector device-type="pc" />
  </div>
</template>

<script>
import ClassSelector from '@/components/shared/ClassSelector.vue';

export default {
  name: 'DesktopClassSelector',
  components: {
    ClassSelector
  }
}
</script>

<style scoped>
.desktop-class-selector {
  width: 100%;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

/* PC端特定样式可以在这里添加 */
</style>